import { cancelRun } from './cancelRun';
import { create } from './create';
import { createFromTemplate } from './createFromTemplate';
import { deleteEndpoint } from './delete';
import { duplicate } from './duplicate';
import { generatePayload } from './generatePayload';
import { get } from './get';
import { getSecretsKeys } from './getSecretsKeys';
import { invoke } from './invoke';
import { list } from './list';
import { patch } from './patch';
import { runLogs } from './runLogs';
import { runs } from './runs';
import { test } from './test';

export { type CreateFunctionPayload, type CreateHookPayload } from './create';
export { type CreateHookFromTemplatePayload } from './createFromTemplate';
export { type DuplicateHookPayload } from './duplicate';
export { type GeneratePayloadPayload } from './generatePayload';
export { type HooksListQuery } from './list';
export { type HookPatchPayload } from './patch';
export { type Runs, type RunsQuery } from './runs';
export { type TestPayload, type TestResponse } from './test';

export const hooks = {
  test,
  cancelRun,
  create,
  createFromTemplate,
  delete: deleteEndpoint,
  duplicate,
  get,
  invoke,
  list,
  patch,
  runs,
  runLogs,
  getSecretsKeys,
  generatePayload,
};
